'use strict';
function selectAllOnFocus() {
  return {
    restrict: 'A',
    replace: false,
    link: function (scope, element) {
      element.on('focus', function () {
        var domElement = element[0];
        if (angular.isFunction(domElement.setSelectionRange)) {
          domElement.setSelectionRange(0, domElement.value.length);
        }
      });
    },
  };
}

angular.module('dokiv')
  .directive('selectAllOnFocus', [selectAllOnFocus]);



//////////////////
// WEBPACK FOOTER
// ./scripts/app/selectAllOnFocus.js
// module id = 270
// module chunks = 0